/*
  requires the following markup:

  <product-quick-add>
    {%- assign form_id = 'productQuickAdd-' | append: product.id -%}

    {%- form 'product', product, id: form_id -%}
      <input type="hidden" name="quantity" min="1" value="1">
      <input
        type="hidden"
        name="id"
        value="{{ product.selected_or_first_available_variant.id  }}"
        data-product-quick-add-el="variant"
      >

      <button class="lookbook-banner__product-item-button"
        type="submit"
        name="add"
        data-value="{{ product.selected_or_first_available_variant.id  }}"
        data-product-quick-add-el="submit"
      >
        {{ 'product.add_to_cart' | t }}
      </button>
    {%- endform -%}
  </product-quick-add>
*/

class ProductQuickAdd extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeElements();
    this.setupEventListeners();
  }

  initializeElements() {
    this.els = {
      submit: this.querySelectorAll('[data-product-quick-add-el="submit"]'),
      selectedVariant: this.querySelector('[data-product-quick-add-el="variant"]')
    };
  }

  setupEventListeners() {
    this.els.submit.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();

        const variantId = event.currentTarget.getAttribute('data-value');

        this.els.selectedVariant.value = variantId;

        window.Moonbase.ajaxCart.handleAddToCartClick(event);
      });
    });
  }
}

customElements.define('product-quick-add', ProductQuickAdd);
